export default "__VITE_ASSET__BHwOenp4__"